import { RootState } from '../../../store';

export const selectActiveModal = (state: RootState) => {
  return state.ui.modal.activeModalId;
};
